<script>
	import {onMount, setContext} from 'svelte';
	import Router from 'svelte-spa-router';
	import {routes} from './routes.js';
	import {session, userMap} from './Utilities/Session.svelte';
	import Login, {checkLoggedIn, logOut} from './Login/Login.svelte';
	import Confirmation, {confirm} from './Components/Confirmation.svelte';
	import Loader from './Components/Loader.svelte';
	import {addFormModal} from './Forms/ModalFormManager.svelte';
	import ModalManager from './Components/ModalManager.svelte';
	import ContextMenu from './Components/ContextMenu.svelte';
	import NotePadPopup from './Components/NotePadPopup.svelte';

	import {handleError} from './Utilities/handlePromise';

	import { NotificationDisplay, notifier } from '@beyonk/svelte-notifications'

	import {syncStatus, db, uuid, ENV} from './Database.svelte';

	export let isNotePadPopup = false;

	let previousSyncStatus = 0;

	function goOnline() {
		let username = window.localStorage.getItem("kroll_username")
		session.set({
			workOffline: false,
			user: {
				email: username
			}
		})
	}

	function changePassword() {
		addFormModal({
			fields: [
				{
					name: "pwd",
					type: "password",
					label: "New Password"
				},
				{
					name: "pwd_confirm",
					type: "password",
					label: "Confirm Password"
				},
			]
		}).then(formData => {
			if (formData.pwd != formData.pwd_confirm) {
				alert("Passwords do not Match");
			} else {
				if ($session.user) {
					let data = $session.user;
					data.pwd = formData.pwd;

					const options = {
						method: 'POST',
						body: JSON.stringify(data),
						headers: {
							'Content-Type': 'application/json'
						}
					}
					fetch(`/api/auth/users/${$session.user.id}`, options).then((res) => {
						notifier.success("Password Updated");
					})
				} else {
					notifier.warning("Invalid User Context")
				}
			}
		}).catch(handleError)
	}

	// set up subscription so the map get's populated
	$: usersMap = $userMap;

	onMount(() => {
		checkLoggedIn();
		/*
		session.set({
			workOffline: true,
			user: {
				roles: ["admin"],
				email: "Isaiah.Jensen@kroll.com",
				name:"Isaiah Jensen"
			}
		});
		//*/

		if (window.location.hash.startsWith("#/notepadPopup/")) {
			isNotePadPopup = true;
		}

		const unsub = syncStatus.subscribe((status) => {
			if (previousSyncStatus == 1 && status == 0) {
				confirm("Katana is no longer syncing data. Refresh the page to try to reconnect.", true);
			}

			previousSyncStatus = status;
		})

		// log unhandled exceptions
		window.onerror = (msg, url, lineNo, columnNo, ex) => {
			if (ENV == "dev") return;

			var errorData = {
				_id: uuid(),
				user: $session.user,
				name: ex.name, // e.g. ReferenceError
				message: ex.message, // e.g. x is undefined
				url: document.location.href,
				stack: ex.stack // stacktrace string; remember, different per-browser!
			};
			fetch('/log/', {
				method: "PUT",
				body: JSON.stringify(errorData),
				headers: {
					'Content-Type': 'application/json'
				}
			});
		}


		return () => {
			unsub();
		}
	});
</script>

<Loader loading={!$session.workOffline && $syncStatus == -1} message="Syncing.. This may take several minutes for the first sync">
{#if !$session.loggedIn && !$session.workOffline}
	<Login></Login>
{:else}

	{#if isNotePadPopup}
		<NotePadPopup></NotePadPopup>
	{:else}
		<div class="layout">
			<nav class="navbar is-light" role="navigation" aria-label="main navigation">
				<div class="navbar-brand">
					<a class="navbar-item" href="#/" title="Keith's Annual Termination Announcement of Non-performing Associates">
						<img alt="Keith's Annual Termination Announcement of Non-performing Associates" src="images/KATana_logo.png"> &nbsp; KATana
					</a>
				</div>
				<div class="navbar-menu">
					<div class="navbar-start">
						<a class="navbar-item" href="#/">
							Assessments
						</a>
						<a class="navbar-item" href="#/assessmentTypes">
							Assessment Types
						</a>
						<a class="navbar-item" href="#/questionLibrary">
							Question Library
						</a>
						<a class="navbar-item" href="#/libraries">
							Libraries
						</a>
						<div class="navbar-item has-dropdown is-hoverable">
							<span class="navbar-link">Reporting</span>
							<div class="navbar-dropdown">
								<a class="navbar-item" href="#/recommendations">
									Recommendations (Legacy)
								</a>
								<a class="navbar-item" href="#/dashboards">
									Dashboards
								</a>
								<a class="navbar-item" href="#/SVGList">
									Report Images
								</a>
								<a class="navbar-item" href="#/reportGraphic">
									Report Graphics
								</a>
								<a class="navbar-item" href="#/templates">
									Template Snippets
								</a>
								<a class="navbar-item" href="#/templateSlides">
									Template Slides
								</a>
							</div>
						</div>
						<a class="navbar-item" href="#/frameworkReference">
							Frameworks
						</a>
						<a class="navbar-item" href="#/recurringAssessmentMappings">
							Recurring Assessment Mappings
						</a>
					</div>
					<div class="navbar-end">
						<a class="navbar-item" href="#/manageSync">
							<b class="{$syncStatus ? 'online' : 'offline'}">Sync Status: {$syncStatus ? "Online" : "Offline"} ({db.name})</b>
							{#if $session.workOffline}
								&nbsp;(<span class='link' on:click={goOnline}>Go Online</span>)
							{/if}
						</a>
						{#if !$session.workOfflin}
							<span class="pointer navbar-item" on:click={changePassword}>
								Change Password
							</span>
						{/if}
						<span class=" pointer navbar-item" on:click="{logOut}">
							Log Out
						</span>
					</div>
				</div>
			</nav>
			<section class="section viewport">
				<div class="container viewport is-fluid p-0">
					<Router {routes}></Router>
				</div>
			</section>
		</div>
	{/if}

	<ModalManager />
	<Confirmation />
	<NotificationDisplay />
	<ContextMenu />

{/if}
</Loader>

<style>
	.online {
		color: green !important;
	}

	.offline {
		color: red !important;
	}

	.link {
		cursor: pointer;
		text-decoration: underline;
	}
</style>